@if (open) {
  <div class="modal-backdrop" role="presentation">
    <section class="modal-panel option-panel" role="dialog" aria-modal="true" [attr.aria-label]="title">
      <header class="modal-header">
        <div>
          <h2>{{ title }}</h2>
          @if (!optionGroups.length) {
            <p>{{ singleSelect ? 'Select one option from the list.' : 'Select one or more options from the list.' }}</p>
          }
        </div>
        <button type="button" class="icon-close" (click)="closed.emit()" aria-label="Close">x</button>
      </header>

      <div class="option-scroll-body">
        @if (optionGroups.length) {
          <div class="option-group-stack">
            @for (group of filteredOptionGroups; track group.label) {
              <section class="option-group-section">
                <h3>{{ group.label }}</h3>
                <div class="option-grid grouped-option-grid">
                  @for (option of group.options; track option) {
                    <button
                      type="button"
                      class="option-tile"
                      [class.selected]="selected.has(optionValue(option))"
                      (click)="toggle(option)"
                      [title]="optionLabel(option)">
                      <span>{{ optionLabel(option) }}</span>
                    </button>
                  }
                </div>
              </section>
            }
          </div>
        } @else {
          <div class="option-grid">
          @for (option of filteredOptions; track option) {
            <button
              type="button"
              class="option-tile"
              [class.selected]="selected.has(option)"
              (click)="toggle(option)"
              [title]="option">
              <span>{{ option }}</span>
            </button>
          }
          </div>
        }

        @if (!hasOptions) {
          <p class="option-empty-message">No lookup options are available on this device yet. Connect once and refresh the app to cache lookup lists for offline use.</p>
        }

        @if (hint) {
          <p class="option-hint"><strong><em>{{ hint }}</em></strong></p>
        }
      </div>

      <footer class="modal-footer">
        @if (optionGroups.length) {
          <button type="button" class="btn secondary" (click)="closed.emit()">Close</button>
          <button type="button" class="btn primary" (click)="apply()">Use Selected</button>
        } @else {
          <button type="button" class="btn secondary" (click)="closed.emit()">Cancel</button>
          <button type="button" class="btn primary" (click)="apply()">Apply</button>
        }
      </footer>
    </section>
  </div>
}
